
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import _ from 'lodash';
    import moment from 'moment';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Patient from '@/types/Patient';
    import api from '@/services/Api';
    import axios, { AxiosResponse, CancelTokenSource } from 'axios';
    import { DataTableHeaders } from '@/types';
    import { PatientSearchItem } from '@/components/Impfverwaltung/Patient/PatientSearch.vue';
    import { Termin } from '@/types/Terminkalender';
    import { TerminSucheFilter, ValidationRules } from '@/store/types';
    import { VForm } from '@/types/Components';
    import { SetSearchPayload } from '@/store/terminkalender';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('terminkalender', ['kalender', 'loaders']),
            ...mapState('terminkalender', { terminSuche: 'suche' }),
        },
        methods: {
            ...mapActions('terminkalender', ['deleteTermin', 'searchKalender', 'printTermine', 'exportTermine']),
            ...mapMutations('terminkalender', ['setTermin', 'setDialog', 'setSearch']),
            ...mapActions('patient', ['loadPatient']),
        },
    })
    export default class TerminkalenderSucheDetail extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
        };

        public terminSuche!: { termine: Termin[]; filter: TerminSucheFilter };
        public rules!: ValidationRules;
        public parseDate!: (input: string | null) => string | null;
        public formatDate!: (input: string | null) => string | null;
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;
        public updateTermin!: (termin: Termin) => void;
        public deleteTermin!: (termin: Termin) => void;
        public searchKalender!: (filter: TerminSucheFilter) => void;
        public setTermin!: (termin: Termin) => void;
        public setDialog!: (visible: boolean) => void;
        public setSearch!: (payload: SetSearchPayload) => void;
        public kalender:any;
        public printTermine!: (payload: any) => void;
        public exportTermine!: (payload: any) => void;

        public filter: TerminSucheFilter = {
            von: moment().format('YYYY-MM-DD'),
            bis: '',
            zeit: '',
            dauer: '',
            platznr: '',
            terminart: '',
            erschienen: '',
            patient: '',
            hinweis: '',
        };

        public selectedTermine: Termin[] = [];
        public search = '';
        public validSearch = true;
        public searched = false;
        public loading = false;
        public items: PatientSearchItem[] = [];
        public searchApiCall: _.DebouncedFunc<(query: string) => void> | null = null;
        public source: CancelTokenSource | null = null;

        public mounted(): void {
            this.search = '';
            this.validSearch = true;
            this.items = [];
        }

        public get headers(): DataTableHeaders<Termin, 'actions' | 'patient'> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Datum', value: 'datum', sortable: false },
                { text: 'Zeit', value: 'zeit', sortable: false },
                { text: 'Dauer', value: 'dauer', sortable: false },
                { text: 'Patient', value: 'patientName', sortable: false },
                { text: 'Hinweis', value: 'hinweis', sortable: false },
            ];
        }

        public get canSearch(): boolean {
            return this.datumBisErrorMessages.length === 0 && this.datumBisErrorMessages.length === 0;
        }

        public getStandardTerminart(): any {
            for (var cnt = 0; this.kalender.arten.length > cnt; cnt++) {
                if (this.kalender.arten[cnt].standard === 'j') {
                    this.filter.terminart = this.kalender.arten[cnt].terminart;
                }
            }
        }

        public get patientName(): string {
            return typeof this.filter.patient === 'object'
                ? (this.filter.patient as PatientSearchItem).name ?? ''
                : this.filter.patient as string;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.items = [];
                this.searched = false;
                this.filter = this.terminSuche.filter;

                this.datumVonErrorMessages = [];
                this.datumVonFormatted = this.formatDate(this.filter.von);

                this.datumBisErrorMessages = [];
                this.datumBisFormatted = this.formatDate(this.filter.bis);
                this.filter = {
                  von: moment().format('YYYY-MM-DD'),
                  bis: '',
                  zeit: '',
                  dauer: '',
                  platznr: '',
                  terminart: '',
                  erschienen: '',
                  patient: '',
                  hinweis: '',
                };
                this.onClickSearch();
                //this.getStandardTerminart();

            }
        }

        @Watch('loaders.save')
        public onChangeTermin(saving: boolean): void {
            if (this.visible && !saving) {
                this.onClickSearch();
            }
        }

        @Watch('loaders.delete')
        public onChangeDelete(deleting: boolean): void {
            if (this.visible && !deleting) {
                this.onClickSearch();
            }
        }

        @Watch('search', { immediate: true })
        public onChangeSearch(search: string): void {
            if (search && search !== this.patientName) {
                this.querySelections(search);
            }
        }

        public datumVonMenu = false;
        public datumVonFormatted: string | null = null;
        public datumVonErrorMessages: string[] = [];

        @Watch('filter.von')
        public onChangeFilterVon(date: string | null): void {
            this.datumVonFormatted = this.formatDate(this.filter.von);

            if (this.rules.required(date) === true) {
                this.datumVonErrorMessages = [];

                for (const rule of [this.rules.validDate]) {
                    const valid = rule(this.filter.von);
                    if (valid !== true) {
                        this.datumVonErrorMessages.push(valid as string);
                    }
                }
            }
        }

        public datumBisMenu = false;
        public datumBisFormatted: string | null = null;
        public datumBisErrorMessages: string[] = [];

        @Watch('filter.bis')
        public onChangeFilterBis(date: string | null): void {
            this.datumBisFormatted = this.formatDate(this.filter.bis);

            if (this.rules.required(date) === true) {
                this.datumBisErrorMessages = [];

                for (const rule of [this.rules.validDate]) {
                    const valid = rule(this.filter.bis);
                    if (valid !== true) {
                        this.datumBisErrorMessages.push(valid as string);
                    }
                }
            }
        }

        public querySelections(query: string): void {
            this.validSearch = query.trim().length >= 3 && query[0] !== ' ';

            if (!this.validSearch) {
                this.items = [];
                return;
            }

            this.loading = true;
            this.searched = true;

            if (!this.searchApiCall) {
                this.searchApiCall = _.debounce((query: string) => {
                    if (this.source) {
                        this.source.cancel('cancel ivs/patienten/search');
                    }

                    this.source = axios.CancelToken.source();

                    api.post('ivs/patienten/search', { query }, { cancelToken: this.source.token })
                        .then((res: AxiosResponse) => {
                            const items: PatientSearchItem[] = [];

                            res.data.body
                                .map((data: Partial<Patient>) => new Patient(data))
                                .forEach((patient: Patient, idx: number) => {
                                    items.push({
                                        name: patient.nachname + ' ' + patient.vorname,
                                        id: patient.patnr as number,
                                        geburtsDatum: patient.geburtsdatum ?? '',
                                        adresse: patient.Adresse,
                                    });

                                    if (idx !== res.data.body.length - 1) {
                                        items.push({ divider: true });
                                    }
                                });

                            this.items = items;
                            this.loading = false;
                        })
                        .catch(console.error)
                        .finally(() => {
                            this.source = null;
                        });
                }, 500);
            }
            this.searchApiCall(query);
        }

        public onClickEdit(termin: Termin): void {
            this.setTermin(termin);
            this.setDialog(true);
        }

        public onClickSearch(): void {
            this.searchKalender({
                ...this.filter,
                patient: typeof this.filter.patient === 'object'
                    ? (this.filter.patient as PatientSearchItem).id as number
                    : this.filter.patient as string,
            });
        }

        public onClickPatient(patnr: number): void {
            this.$emit('close');
            this.$router.push('/');
            this.loadPatient({ patnr });
            this.setSearch({ filter: this.filter });
        }

        public onClickClose(): void {
            this.setSearch({ filter: this.filter });
            this.$emit('close');
        }

        public onClickPrint(termine: Termin[], filter: TerminSucheFilter[]) {
            this.printTermine({termine: termine, filter: filter});
        }

        public onClickExport(termine: Termin[], filter: TerminSucheFilter[]) {
            this.exportTermine({termine: termine, filter: filter});
        }
    }
